export default {"src":"https://d2pviq63ux9jcb.cloudfront.net/_next/static/media/blue-bold.3b0838f5.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};